import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["aria-label", "accessibilityLabel", "colorToken", "colorTokenArgs", "id", "size", "filled", "noWrapper", "testID", "UNSAFE_svgProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useStyleSheet } from '@bubble-ui/hook-use-stylesheet';
import { Group } from '@bubble-ui/primitive-group';
import { Shape } from '@bubble-ui/primitive-shape';
import { Surface } from '@bubble-ui/primitive-surface';
import { withProvisionalOverrideFromContext } from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { usePropsFromContext } from '@bubble-ui/provider-props-context';
import { usePropDeprecationWarning } from '@bubble-ui/hook-use-prop-deprecation-warning';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
export var smallActionIconShapeSize = {
  height: 12,
  width: 12
};
export var defaultActionIconShapeSize = {
  height: 20,
  width: 20
};
export var smallActionIconGroupProps = {
  fill: 'none',
  fillRule: 'evenodd'
};
export var defaultAlignedActionIconGroupProps = {
  fill: 'none',
  fillRule: 'evenodd',
  x: 4,
  y: 4
};
export function baseActionIcon(displayName, config) {
  var OverridableActionIcon = props => {
    var {
        'aria-label': ariaLabel,
        accessibilityLabel: ariaLabelDeprecated,
        colorToken,
        colorTokenArgs,
        id,
        // @deprecated v7.0.0
        // @ts-expect-error
        size,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        filled,
        noWrapper,
        testID,
        UNSAFE_svgProps
        /**
         * @deprecated props spreading is outdated and will be removed with v7.0.0
         */
      } = props,
      restOfProps = _objectWithoutProperties(props, _excluded);
    var designVersion = useDesignVersion();
    var actionIconPropsFromContext = usePropsFromContext('ActionIcon');
    var shapeSize = config !== null && config !== void 0 && config.shapeSize ? typeof config.shapeSize === 'function' ? config.shapeSize(props) : config.shapeSize : noWrapper ? smallActionIconShapeSize : defaultActionIconShapeSize;
    var groupProps = noWrapper ? smallActionIconGroupProps : defaultAlignedActionIconGroupProps;
    var path = config.getPath(_objectSpread(_objectSpread({}, props), {}, {
      designVersion
    }));
    usePropsSpreadingDeprecationWarning({
      componentName: displayName,
      props: restOfProps,
      useInstead: 'UNSAFE_svgProps',
      removalDate: 'v7.0.0'
    });
    usePropDeprecationWarning({
      componentName: displayName,
      propName: 'size',
      shouldWarn: size !== undefined,
      removalDate: 'v7.0.0'
    });

    // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
    // Keep passing all props to the style sheet, even if we don't use them ourselves
    var styleSheet = useStyleSheet(OverridableActionIcon, getDefaultStyleSheet, _objectSpread({
      accessibilityLabel: ariaLabel || ariaLabelDeprecated,
      colorToken: colorToken || actionIconPropsFromContext.colorToken,
      colorTokenArgs: colorTokenArgs || actionIconPropsFromContext.colorTokenArgs,
      id,
      noWrapper,
      testID,
      UNSAFE_svgProps
    }, restOfProps));
    return /*#__PURE__*/React.createElement(Surface, _extends({
      id: id
    }, testID ? {
      testID
    } : {}, UNSAFE_svgProps, {
      "aria-label": ariaLabel || ariaLabelDeprecated,
      viewBox: "0 0 ".concat(shapeSize.width, " ").concat(shapeSize.height),
      height: size || shapeSize.height,
      width: size || shapeSize.width
    }, restOfProps), /*#__PURE__*/React.createElement(Group, groupProps, /*#__PURE__*/React.createElement(Shape, _extends({
      d: path
    }, styleSheet === null || styleSheet === void 0 ? void 0 : styleSheet.pathStyle))));
  };
  OverridableActionIcon.displayName = displayName;
  var ActionIcon = withProvisionalOverrideFromContext(OverridableActionIcon);
  return ActionIcon;
}
//# sourceMappingURL=baseActionIcon.js.map